export enum AdminMultimediaThumbVariant {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Mini = 'MINI',
}
